import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取机构列表
 * @param vCom Vue组件
 */
const GetHospitals = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/user/hospitals").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取舌图图片列表
 * @param vCom Vue组件
 */
const GetTonguePicLists = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除舌图
 * @param vCom Vue组件
 */
const DeleteTongue = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/tongue/args", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 批量删除舌图
 * @param vCom Vue组件
 */
const DeleteSomeTongues = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/tongue/list", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 修改患者基本信息
 * @param vCom Vue组件
 */
const ChangePatientDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌图数据导出并创建数据表格
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/export", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 高级筛选：研究指标列表
 * @param vCom Vue组件
 */
const GetTongueTemplates = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/search/templates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 舌图平台高级筛选：研究指标各个题目信息
 * @param vCom Vue组件
 * @param templateId template_id
 */
const GetTongueTopicsOfTemplate = (vCom: any, templateId: string): Promise<any> => {
    const params: any = {
        params: {
            template_id: templateId,
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/search/topics", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌图数据表格列表页
 * @param vCom Vue组件
 */
const GetExportResultsList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/tables", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 查看数据表格（预览）
 * @param vCom Vue组件
 */
const CheckTable = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/data/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导出数据表格
 * @param vCom Vue组件
 */
const ExportTable = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/data/export/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 删除数据表格
 * @param vCom Vue组件
 */
const DeleteTable = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/data/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 报告预览
 * @param vCom Vue组件
 */
const GetTonguePreview = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/report", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 该患者的全部舌图
 * @param vCom Vue组件
 */
const GetPatientAllTongue = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/patient/tongues", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 望舌体、望舌苔、分组 获取详情
 * @param vCom Vue组件
 */
const GetTongueDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/args", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 望舌体、望舌苔、分组 标注
 * @param vCom Vue组件
 */
const SaveTongueDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/args", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch(() => {
                reject();
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌图智能比对
 * @param vCom Vue组件
 */
const Bidui = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/duibi/args", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌图智能比对报告预览
 * @param vCom Vue组件
 */
const BiduiPreview = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/duibi/report2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 局部舌色计算
 * @param vCom Vue组件
 */
const Jubushese = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/part/shese", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 局部苔色计算
 * @param vCom Vue组件
 */
const Jubutaise = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/part/taise", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌上红点计算
 * @param vCom Vue组件
 */
const Hongdian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/redspot", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌图手动分割
 * @param vCom Vue组件
 */
const Fenge = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/cut", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 计算分割后舌图的像素面积
 * @param vCom Vue组件
 */
const CalCuttedTongueArea = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/mianji", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获取创建Oss的初始参数
 * @param vCom Vue组件
 */
const GetOssParams = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                type: "tongue"
            }
        };
        axios.get("api/oss", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

const UploadImage = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/image", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
const UploadVideo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/file", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};



export {
    GetHospitals, GetTonguePicLists, DeleteTongue, DeleteSomeTongues,
    ChangePatientDetail, PostDataExport, GetTongueTemplates, GetTongueTopicsOfTemplate,
    GetExportResultsList, CheckTable, ExportTable, DeleteTable,
    GetTonguePreview, Jubushese, Jubutaise, Hongdian, Fenge, CalCuttedTongueArea,
    GetTongueDetail, GetPatientAllTongue, SaveTongueDetail,
    Bidui, BiduiPreview, GetOssParams, UploadImage, UploadVideo
};
